// Cloudflare Worker + MailChannels email integration
export async function SendEmail({ name, email, subject, message, turnstileToken }) {
  const workerUrl = process.env.REACT_APP_EMAIL_WORKER_URL || 'https://portfolio-email.arthurpangjiade.workers.dev';

  const response = await fetch(workerUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, subject, message, turnstileToken }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to send email');
  }

  return await response.json();
}